import { PropsWithChildren } from 'react'

import Box from 'components/atomic/atoms/box'
import Text from 'components/atomic/atoms/text'

import { DotsCenter } from './dots'

export function SectionTitleContainer(
  props: PropsWithChildren<{ backgroundDots?: true }>,
) {
  return (
    <Box flex="column" items="center" css={{ position: 'relative', gap: '$4' }}>
      {props.backgroundDots && <DotsCenter />}

      {props.children}
    </Box>
  )
}

export function HomepageSectionTitle(props: PropsWithChildren) {
  return (
    <Text
      as="h2"
      weight="bold"
      size={{ '@initial': '4xl', '@sm': '5xl' }}
      align="center"
      css={{
        zIndex: 1,
        mt: '$4',
        textWrap: 'balance',
      }}
    >
      {props.children}
    </Text>
  )
}

export function HomepageSectionSubtitle(props: PropsWithChildren) {
  return (
    <Text
      as="p"
      size="lg"
      color="text2"
      align="center"
      css={{
        zIndex: 1,
        maxWidth: '$3xl',
        textWrap: 'pretty',
      }}
    >
      {props.children}
    </Text>
  )
}
